import React from "react";
import Logomarca from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { Container, Logo, Menu } from "./styles";
import useAuth from "../../hooks/useAuth"


const Header = () => {
    const autenticado = useAuth();

    return(
        <Container>
            <Logo>
                <Link to="/"><img src={Logomarca} alt=""/></Link>
                <p>CRECI 12236</p>
            </Logo>
            <Menu>
                <ul>
                    <li><Link to="/"><span>Home</span></Link></li>
                    {/* <li><span>Imóveis</span></li> */}
                    <li><Link to="/about"><span>Sobre</span></Link></li>
                    <li>{autenticado === null ? null : (
                        <Link to={autenticado ? "/dashboard" : "/login"}>
                            <span>{autenticado ? "Dashboard" : "Login"}</span>
                        </Link>)}
                    </li>
                </ul>
            </Menu>
        </Container>
    )
}

export default Header;